import { DateTime } from 'luxon';
export const RIVER_STATE_ANALYSIS_HOURS = 12;

export function getSiteDataSubset(siteData, minDateTime, maxDateTime) {
  if (siteData === undefined) {
    return undefined;
  }

  if (siteData.length === 0) {
    return [];
  }

  return siteData?.filter((data) => {
    const dataDateTime = DateTime.fromISO(data.timestamp);
    return dataDateTime >= minDateTime && dataDateTime <= maxDateTime;
  } );
}

export function findSiteData(data, siteId) {
  return data?.sites?.find((site) => site.id === siteId);
}

export function getSiteData(data, siteId, type) {
  if (!data) {
    return undefined;
  }

  return findSiteData(data, siteId)?.data.find((siteTypeData) => siteTypeData.type === type)?.data;
}

export function getSiteLastData(data, siteId, type) {
  if (!data) {
    return undefined;
  }

  return findSiteData(data, siteId)?.data.find((siteData) => siteData.type === type)?.latest;
}

export function getSiteState(data, siteId) {
  if (!data) {
    return undefined;
  }

  return findSiteData(data, siteId)?.state;
}

export function getSiteDataSourcesForTypes(site, types) {
  if (!site?.properties?.dataSources || !types || types.length === 0) {
    return undefined;
  }

  const dataSourceStrings = types.map((type) => site.properties.dataSources[type]);
  return dataSourceStrings.join(', ');
}

